import { observer } from 'mobx-react';
import _ from 'lodash';

import { SupervisorApi } from '../../util/api/SupervisorApi';
import { ApiMixin } from "./ApiMixin";

import { Alert } from "../Alert";


//Returns the student object, plus some helper functions
class Supervisor {
    id : "";
    email : "";
    designation : "";
    name : "";
    employerId: 0;

    employerName: "";


    constructor(supervisor = {}, shouldParseValues = false) {

        this.parseValues = this.parseValues.bind(this);
        //Cleans the constructor fields of Formik formatting
        if (shouldParseValues) {
            this.parseValues(supervisor);
        }

        //Adds any default values passed by the developer 
        _.defaults(this, supervisor);

    }

    parseValues(supervisor) {

        if (supervisor.id) {
            this.id = parseInt(supervisor.id);
        }

        this.employerId = parseInt(supervisor.employerId)
    }


    mutate(supervisor = {}) {

        //This takes all matching keys from the supervisor and assigns them to this object
        _.assign(this, _.pick(supervisor, _.keys(this)));
    }


    //Saves/updates object to the api, shows errors or updates state. 
    async save(appStore) {

        const api = ApiMixin(SupervisorApi);

        let response = await api.save(this);
        console.log(response)
        //If there are errors, we iterate over them and display them.
        //Then we return false, in case the parent needs to know we failed.

        if (response.errors.length > 0) {
            _.forEach(response.errors, (error) => {
                appStore.addAlert(error);
            });

            return response;
        }

        //If this already exists in the store, get it we'll be updating it both on api and in store.
        //We also need to check if it is the most recent payperiod (think about another way to do this.)
        let newSupervisorObject = null;

        if (this.id) {

            newSupervisorObject = appStore.supervisors.getById(this.id);

            console.log(newSupervisorObject)

            //Diff any changes between store and response.
            newSupervisorObject.mutate(this);

        }
        //If not, we're going to save it to the API, and to push it to the store
        else {

            newSupervisorObject = new Supervisor(response.data);

            console.log(newSupervisorObject)

            appStore.addItem({ type: "supervisor", data: newSupervisorObject });
        }

        //Success alert
        let successAlert = new Alert("Successfully saved", "Successfully saved supervisor.", "sucess");
        appStore.addAlert(successAlert);

        //Return the new timesheet object  
        return newSupervisorObject;
    }
}


export default Supervisor;